import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import "../../styles/pages/orders/_thankYouPageComponent.scss";
import enctyptionHelper from "../../helpers/encryption.helper";

const ThankYouPageComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
  
    // Extract query parameters
    const queryParams = new URLSearchParams(location.search);
    const orderNumber = queryParams.get("orderNumber");
    const encryptedDocumentLink = queryParams.get("documentLink");
  
    // Decrypt the documentLink
    let documentLink;
    try {
      if (encryptedDocumentLink) {
        documentLink = enctyptionHelper.decrypt(encryptedDocumentLink);
      }
    } catch (error) {
      console.error("Failed to decrypt document link:", error);
    }
  
    // 0029 (R2): the order is identified by its number alone. A missing document link is NOT a
    // failure (the order is persisted) — only the absence of an orderNumber is "not found".
    if (!orderNumber) {
      return (
        <div className="thank-you-page">
          <h1>לא נמצאה הזמנה להצגה</h1>
          <button onClick={() => navigate("/")}>חזרה לדף הבית</button>
        </div>
      );
    }

    return (
      <div className="thank-you-page">
        <h1>תודה רבה על ההזמנה!</h1>
        <p>מספר ההזמנה שלך הוא: {orderNumber}</p>
        {documentLink ? (
          <>
            <p>ניתן להוריד את מסמך ההזמנה בלחיצה על הכפתור הבא:</p>
            <a href={documentLink} download className="download-button">
              הורד את המסמך
            </a>
          </>
        ) : (
          <p>מסמך ההזמנה יהיה זמין בקרוב.</p>
        )}
      </div>
    );
  };
  

export default ThankYouPageComponent;
